// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__3wHWZ","picture":"Gallery_picture__snM9S"};